module.exports = __webpack_public_path__ + "static/media/car2.29842817.jpg";